import ClassHelper from '../ClassHelper';
import Excursion from '../excursion/Excursion';
import Limit from './Limit';
import ScheduleSubdivision from './ScheduleSubdivision';

class ScheduleExcursion extends ClassHelper {
  constructor({ excursion, limit, subdivisions = [] } = {}) {
    super(...arguments);
    this.excursion = this.ref(excursion, Excursion);
    this.limit = this.obj(limit, Limit);
    this.subdivisions = this.array(subdivisions, ScheduleSubdivision);
  }
}

export default ScheduleExcursion;